import { yupResolver } from "@hookform/resolvers/yup";
import { Modal, Button } from "antd";
import { deductPassengerWalletApi } from "api/passengerWallet";
import LabeledInput from "components/Form/LabeledInput";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { IUpdatePassengerWalletBalance, IPassengerWallet } from "models/passengerWallet";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { updateWalletBalanceValidator } from "validators/createWallet.validator";

interface IProp {
  open: boolean;
  wallet: IPassengerWallet;
  handleClose: () => void;
}

export default function DeductBalanceModal({ open, wallet, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadWallets } = useDataLoadingContext();
  const { handleSubmit, control } = useForm<IUpdatePassengerWalletBalance>({
    resolver: yupResolver(updateWalletBalanceValidator),
  });

  const onSubmit = async (input: IUpdatePassengerWalletBalance) => {
    setLoading(true);
    const { data, error } = await deductPassengerWalletApi(wallet.id, input);
    if (data) {
      showSuccess("Passenger wallet balance deducted successfully");
      handleClose();
      loadWallets();
    } else showError(error!.message);
    setLoading(false);
  };

  return (
    <Modal open={open} title={null} footer={null} centered>
      <form onSubmit={handleSubmit(onSubmit)}>
        {" "}
        <div className="w-full text-start">
          <h3 className="text-xl font-semibold my-4">
            Deduct Wallet from {wallet.passenger.first_name} {wallet.passenger.last_name}
          </h3>
          <LabeledInput
            control={control}
            label="Enter Balance"
            name="balance"
            placeholder="0.00"
            type="number"
          />
          <div className="w-full flex mt-7 items-center justify-end gap-x-3">
            <Button onClick={handleClose}>Cancel</Button>
            <Button htmlType="submit" loading={loading} type="primary">
              Deduct
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
